module.exports = __webpack_public_path__ + "media/images/basic_logos/calendar-b46e091046106010c78a3b80e7f94d9e.svg";